import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          minHeight: "40px",
          alignItems: "center",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", marginLeft: "8px", marginRight: "8px" }}>
          <div>
            <a
              href={t("privacyPolicy")}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none" }}
            >
              <span>{t("footer.privacy")}</span>
            </a>
            <span
              className="separator"
              style={{
                paddingLeft: "8px",
                paddingRight: "8px",
              }}
            >
              |
            </span>
          </div>
          <div>
            <a
              href={t("imprint")}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none" }}
            >
              <span>{t("footer.imprint")}</span>
            </a>
          </div>
        </div>

        <div>
          <p
            className="copyright"
            style={{
              paddingLeft: "8px",
            }}
          >
            © Copyright Swisscom Trust Services {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};
